export default __webpack_public_path__ + "static/media/building.c083820a.svg";